import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import PrivacyPolicy from "./components/privacyPolicy";
import GlobalTermsAndConditions from "./components/termsAndConditions";
import CookiePolicy from "./components/cookiePolicy";
import { TStore } from "models";
import styles from "./styles.module.scss";
import {
	getLegalAgreementContent,
	getPublicPolicyPaymentsEnabled,
	isLegalAgreementAvailable,
} from "./legalAgreementContent";
import { isItAWhiteLabel } from "utils";

const LegalAgreements = () => {
	const location = useLocation();
	const previewWhiteLabelCommunity = useSelector(
		(state: TStore) => state.previewWhiteLabelCommunity,
	);
	const content = getLegalAgreementContent(
		location.pathname,
		previewWhiteLabelCommunity,
	);
	const isWhiteLabel = Boolean(isItAWhiteLabel());
	const paymentsEnabled = getPublicPolicyPaymentsEnabled(isWhiteLabel);

	if (
		!isLegalAgreementAvailable(
			location.pathname,
			previewWhiteLabelCommunity,
			isWhiteLabel,
		)
	) {
		return <Navigate to="/auth/sign-in" replace />;
	}

	return (
		<div className={styles.container}>
			{location.pathname.indexOf("/terms-and-conditions") !== -1 ? (
				<GlobalTermsAndConditions
					data={content}
					communityName={previewWhiteLabelCommunity?.name}
				/>
			) : location.pathname.indexOf("/privacy-policy") !== -1 ? (
				<PrivacyPolicy
					data={content}
					communityName={previewWhiteLabelCommunity?.name}
					paymentsEnabled={paymentsEnabled}
				/>
			) : (
				<CookiePolicy
					data={previewWhiteLabelCommunity?.cookie_policy}
					communityName={previewWhiteLabelCommunity?.name}
				/>
			)}
		</div>
	);
};

export default LegalAgreements;
